
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ShortTermPage = lazy(() => import('../pages/short-term/page'));
const LongTermPage = lazy(() => import('../pages/long-term/page'));
const LandlordsPage = lazy(() => import('../pages/landlords/page'));
const PropertiesPage = lazy(() => import('../pages/properties/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const LandlordApplicationPage = lazy(() => import('../pages/landlord-application/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/short-term',
    element: <ShortTermPage />,
  },
  {
    path: '/long-term',
    element: <LongTermPage />,
  },
  {
    path: '/landlords',
    element: <LandlordsPage />,
  },
  {
    path: '/properties',
    element: <PropertiesPage />,
  },
  {
    path: '/booking',
    element: <BookingPage />,
  },
  {
    path: '/landlord-application',
    element: <LandlordApplicationPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
